import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Icon,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from '@mui/material'
import WbSunnyIcon from '@mui/icons-material/WbSunny'
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import { useContext } from 'react'
import { ProfileContext, ThemeVariation } from '../../contexts/ProfileContext'

export function SettingsSidebarItem() {
  const { theme, changeTheme } = useContext(ProfileContext)

  return (
    <Accordion sx={{ bgcolor: 'background.paper', boxShadow: 'none' }}>
      <AccordionSummary
        sx={{
          height: '40px',
          minHeight: 0,
          px: 0,
          bgcolor: 'inherit',
          borderRadius: '6px',
          '& .MuiListItemIcon-root': {
            color: (theme) => theme.palette.primary.main,
          },
          '&.Mui-expanded': {
            backgroundColor: (theme) => theme.palette.action.selected,
            height: '40px',
            minHeight: 0,
          },
          '&:hover': {
            backgroundColor: (theme) => theme.palette.action.hover,
          },
        }}
      >
        <ListItem>
          <ListItemIcon
            sx={{
              minWidth: '35px',
            }}
          >
            <Icon baseClassName='material-icons-outlined'>{'settings'}</Icon>
          </ListItemIcon>
          <ListItemText
            primary={'Stillingar'}
            primaryTypographyProps={{ fontWeight: 500 }}
          />
        </ListItem>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        <List
          subheader={
            <ListSubheader
              sx={{ bgcolor: 'inherit', p: 0, lineHeight: '2.2rem' }}
            >
              Þema
            </ListSubheader>
          }
          sx={{
            '& .MuiButton-root': {
              height: '40px',
              width: '100%',
              borderRadius: 0,
              mt: '-1px',
            },
          }}
        >
          <Button
            startIcon={<WbSunnyIcon />}
            variant={theme === ThemeVariation.Light ? 'contained' : 'outlined'}
            onClick={() => changeTheme(ThemeVariation.Light)}
          >
            Ljóst
          </Button>
          <Button
            sx={{ pr: '24px' }}
            startIcon={<SettingsBrightnessIcon />}
            variant={theme === ThemeVariation.System ? 'contained' : 'outlined'}
            onClick={() => changeTheme(ThemeVariation.System)}
          >
            Kerfi
          </Button>
          <Button
            startIcon={<DarkModeIcon />}
            variant={theme === ThemeVariation.Dark ? 'contained' : 'outlined'}
            onClick={() => changeTheme(ThemeVariation.Dark)}
          >
            Dökkt
          </Button>
        </List>
      </AccordionDetails>
    </Accordion>
  )
}
